export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/Coins.309b108d.svg","height":67,"width":73,"blurWidth":0,"blurHeight":0};